module.exports = __webpack_public_path__ + "img/pantalla-6-2.23c0924f.png";